import { array, object, string } from 'yup';

export const addTagsFormSchema = object({
  tags: array().of(
    object({
      key: string().required(),
      value: string()
        .required()
        .test({
          name: 'number validation',
          message: 'Must be a number',
          test: (value, other) => {
            if (other.parent?.attributeType === 'NUMBER') {
              const pattern = /^\d+\.?\d*$/;
              return pattern.test(value);
            }
            return true;
          },
        })
        .test({
          name: 'date validation',
          message: 'Value must be entered in YYYY-MM-DD format',
          test: (value, other) => {
            if (other.parent?.attributeType === 'DATE') {
              const pattern = /^\d{4}-\d{2}-\d{2}$/;
              return pattern.test(value);
            }
            return true;
          },
        }),

      attributeType: string(),
      title: string(),
      collectionValues: array().of(string()),
    }),
  ),
});
